(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uw-buy-form"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__uwProductCardInit) return;
    window.__uwProductCardInit = true;

    function say(form, message, isError, basketUrl, basketLabel) {
      var node = form.querySelector('[data-uw-buy-status]');
      if (!node) return;
      node.textContent = message || '';
      node.classList.toggle('is-error', !!isError);
      if (message && basketUrl && basketLabel) {
        node.appendChild(document.createTextNode(' '));
        var link = document.createElement('a');
        link.href = basketUrl;
        link.textContent = basketLabel;
        node.appendChild(link);
      }
    }

    function refreshCount(cartUrl) {
      if (!cartUrl) return;
      return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var link = document.querySelector('[data-uw-cart-link]');
          if (!link) return;
          var sup = link.querySelector('[data-uw-cart-count]');
          if (!cart.item_count) {
            if (sup) sup.parentNode.removeChild(sup);
            return;
          }
          if (!sup) {
            sup = document.createElement('sup');
            sup.setAttribute('data-uw-cart-count', '');
            link.insertBefore(sup, link.firstChild);
          }
          sup.textContent = cart.item_count;
        })
        .catch(function () {});
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('[data-uw-buy-form]')) return;
      event.preventDefault();

      var d = form.dataset;
      var button = form.querySelector('[data-uw-buy-button]');
      if (button) {
        button.disabled = true;
        button.textContent = d.uwLabelAdding;
      }
      say(form, '', false);

      fetch(form.getAttribute('action') + '.js', { method: 'POST', body: new FormData(form) })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (r) {
          if (!r.ok) {
            say(form, (r.data && r.data.description) || d.uwLabelError, true);
            return;
          }
          say(form, d.uwLabelAdded, false, d.uwCartUrl, d.uwLabelBasket);
          var status = form.querySelector('[data-uw-buy-status]');
          document.dispatchEvent(new CustomEvent('uw:sparkle', { detail: { target: status } }));
          return refreshCount(d.uwCartUrl);
        })
        .catch(function () {
          say(form, d.uwLabelError, true);
        })
        .then(function () {
          if (button) {
            button.disabled = false;
            button.textContent = d.uwLabelAdd;
          }
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uw-radio-prompt"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__uwRadioPromptInit) return;
    window.__uwRadioPromptInit = true;

    var STORAGE_KEY = 'uw-radio-prompt-dismissed';

    function isDismissed() {
      try {
        return window.sessionStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    function remember() {
      try {
        window.sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {}
    }

    function init() {
      var prompt = document.querySelector('[data-uw-radio-prompt]');
      if (!prompt) return;
      var next = prompt.nextElementSibling;
      if (!next || !next.querySelector('[data-uw-radio]')) return;
      if (isDismissed()) return;
      prompt.hidden = false;

      var dismiss = prompt.querySelector('[data-uw-radio-prompt-dismiss]');
      if (!dismiss) return;
      dismiss.addEventListener('click', function () {
        prompt.hidden = true;
        remember();
        var play = next.querySelector('[data-uw-radio-play]');
        if (play && play.focus) play.focus();
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uw-radio"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var SOUND_FONT_ATTR = 'sound-font';

    var LOADING_TEXT = 'loading…';

    var libPromise = null;

    var audioCtx = null;

    function unlockAudio() {
      if (audioCtx) return audioCtx;
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return null;
      try {
        audioCtx = new Ctx();
        if (audioCtx.state === 'suspended' && audioCtx.resume) audioCtx.resume();
        return audioCtx;
      } catch (err) {
        console.warn('[uw-radio] could not open an audio context up front. Playback may ' +
          'need a second press.', err);
        audioCtx = null;
        return null;
      }
    }

    var players = [];

    function loadLibrary(url) {
      if (libPromise) return libPromise;
      libPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = url;
        s.async = true;
        s.onload = resolve;
        s.onerror = function () {
          libPromise = null;
          reject(new Error('[uw-radio] could not load the player engine from ' + url));
        };
        document.head.appendChild(s);
      });
      return libPromise;
    }

    function whenReady(el) {
      return new Promise(function (resolve) {
        el.addEventListener('load', function onLoad() {
          if (!el.noteSequence) return;
          el.removeEventListener('load', onLoad);
          resolve();
        });
      });
    }

    function setup(root) {
      if (root.hasAttribute('data-uw-radio-ready')) return;
      root.setAttribute('data-uw-radio-ready', '');

      var playBtn = root.querySelector('[data-uw-radio-play]');
      var stopBtn = root.querySelector('[data-uw-radio-stop]');
      var select = root.querySelector('[data-uw-radio-select]');
      var nowEl = root.querySelector('[data-uw-radio-now]');
      var emptyArt = root.querySelector('[data-uw-radio-art-empty]');
      var closeBtn = root.querySelector('[data-uw-radio-close]');
      var popout = root.querySelector('[data-uw-radio-popout]');
      var covers = [].slice.call(root.querySelectorAll('[data-uw-radio-cover]'));
      var listRows = [].slice.call(root.querySelectorAll('[data-uw-radio-row]'));
      var isFull = root.classList.contains('uw-player--full');
      var libUrl = root.getAttribute('data-uw-radio-lib');

      if (!playBtn || !select || !select.options.length || !libUrl) return;

      var player = null;

      function currentOption() {
        return select.options[select.selectedIndex];
      }

      function showTrackName() {
        var opt = currentOption();
        if (opt && nowEl) nowEl.textContent = opt.textContent.trim();
      }

      function syncToSelection() {
        var opt = currentOption();
        if (!opt) return;
        showTrackName();

        var shown = null;
        covers.forEach(function (img) {
          var isCurrent = img.getAttribute('data-uw-radio-cover') === opt.value;
          img.classList.toggle('is-current', isCurrent);
          if (isCurrent) shown = img;
        });
        if (emptyArt) emptyArt.classList.toggle('is-hidden', !!shown);

        var url = opt.getAttribute('data-uw-radio-url');
        if (player && player.getAttribute('src') !== url) player.src = url;
      }

      function markPlaying(on) {
        root.classList.toggle('is-playing', on);
      }

      function markLoading(on) {
        root.classList.toggle('is-loading', on);
        if (!nowEl) return;
        if (on) nowEl.textContent = LOADING_TEXT;
        else showTrackName();
      }

      function buildPlayer() {
        var el = document.createElement('midi-player');
        el.className = 'uw-player__engine';
        el.setAttribute(SOUND_FONT_ATTR, '');
        if (!isFull) el.setAttribute('loop', '');
        el.addEventListener('start', function () { markPlaying(true); });
        el.addEventListener('stop', function (e) {
          if (isFull && e.detail && e.detail.finished) advanceTrack();
        });
        el.addEventListener('stop', function () { markPlaying(false); });
        var ready = whenReady(el);
        el.src = currentOption().getAttribute('data-uw-radio-url');
        root.appendChild(el);
        players.push(el);
        return { el: el, ready: ready };
      }

      playBtn.addEventListener('click', function () {
        if (player) {
          player.start();
          return;
        }
        unlockAudio();

        playBtn.disabled = true;
        markLoading(true);
        loadLibrary(libUrl).then(function () {
          var built = buildPlayer();
          player = built.el;
          return built.ready;
        }).then(function () {
          markLoading(false);
          player.start();
        }).catch(function (err) {
          console.error(err);
          markLoading(false);
          markPlaying(false);
        }).then(function () {
          playBtn.disabled = false;
        });
      });

      if (stopBtn) {
        stopBtn.addEventListener('click', function () {
          if (player) player.stop();
        });
      }

      select.addEventListener('change', function () {
        var wasPlaying = root.classList.contains('is-playing');
        if (player && wasPlaying) player.stop();
        syncToSelection();
        if (!player || !wasPlaying) return;
        markLoading(true);
        whenReady(player).then(function () {
          markLoading(false);
          player.start();
        });
      });

      listRows.forEach(function (row) {
        row.addEventListener('click', function () {
          var value = row.getAttribute('data-uw-radio-value');
          if (select.value === value) return;
          select.value = value;
          select.dispatchEvent(new Event('change'));
        });
      });

      function advanceTrack() {
        if (!select.options.length) return;
        select.selectedIndex = (select.selectedIndex + 1) % select.options.length;
        select.dispatchEvent(new Event('change'));
      }

      function syncRows() {
        listRows.forEach(function (row) {
          var isCurrent = row.getAttribute('data-uw-radio-value') === select.value;
          row.classList.toggle('is-current', isCurrent);
          if (isCurrent) row.setAttribute('aria-current', 'true');
          else row.removeAttribute('aria-current');
        });
      }
      select.addEventListener('change', syncRows);

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          if (window.opener) window.close();
        });
      }

      if (popout) {
        popout.addEventListener('click', function (e) {
          if (player) player.stop();

          var win = window.open(popout.href, 'uwradio', 'width=880,height=620,menubar=no,toolbar=no,location=no');
          if (win) {
            e.preventDefault();
            win.focus();
          }
        });
      }

      select.selectedIndex = 0;
      syncToSelection();
      syncRows();
    }

    function run() {
      var roots = document.querySelectorAll('[data-uw-radio]');
      for (var i = 0; i < roots.length; i++) setup(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', run);
      document.addEventListener('shopify:section:unload', function () {
        players.forEach(function (p) {
          try { p.stop(); } catch (err) {  }
        });
        players = [];
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uw-sparkles"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__uwSparklesInit) return;
    window.__uwSparklesInit = true;

    var SIZE_MIN = 20;
    var SIZE_MAX = 40;
    var PEAK_MIN = 0.75;
    var PEAK_MAX = 1;

    var TRAIL_MAX = 60;
    var TRAIL_INTERVAL = 20;
    var TRAIL_DRIFT = 55;
    var TRAIL_LIFE_MIN = 750;
    var TRAIL_LIFE_MAX = 1000;

    var BURST_MIN = 25;
    var BURST_MAX = 40;
    var BURST_SPREAD = 78;
    var BURST_LIFE_MIN = 700;
    var BURST_LIFE_MAX = 950;

    var layer = null;
    var alive = 0;
    var lastTrail = 0;
    var pending = false;
    var pointerX = 0;
    var pointerY = 0;

    function prefersReducedMotion() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function hasFinePointer() {
      return !!(window.matchMedia && window.matchMedia('(pointer: fine) and (hover: hover)').matches);
    }

    function getLayer() {
      if (layer && layer.isConnected) return layer;
      layer = document.createElement('div');
      layer.className = 'uw-sparkles';
      layer.setAttribute('aria-hidden', 'true');
      document.body.appendChild(layer);
      return layer;
    }

    function rand(min, max) {
      return min + Math.random() * (max - min);
    }

    function emit(x, y, drift, life) {
      if (alive >= TRAIL_MAX + BURST_MAX) return;
      var el = document.createElement('span');
      var angle = rand(0, Math.PI * 2);
      var distance = rand(drift * 0.35, drift);
      var size = rand(SIZE_MIN, SIZE_MAX);
      var s = el.style;
      s.setProperty('--uw-sparkle-size', size.toFixed(1) + 'px');
      s.setProperty('--uw-sparkle-tone', Math.random() < 0.5
        ? 'var(--uw-sparkle-gold)'
        : 'var(--uw-sparkle-light)');
      s.setProperty('--uw-sparkle-peak', rand(PEAK_MIN, PEAK_MAX).toFixed(2));
      s.setProperty('--uw-sparkle-life', Math.round(life) + 'ms');
      s.setProperty('--uw-sparkle-from-x', (x - size / 2).toFixed(1) + 'px');
      s.setProperty('--uw-sparkle-from-y', (y - size / 2).toFixed(1) + 'px');
      s.setProperty('--uw-sparkle-to-x', (x - size / 2 + Math.cos(angle) * distance).toFixed(1) + 'px');
      s.setProperty('--uw-sparkle-to-y', (y - size / 2 + Math.sin(angle) * distance + distance * 0.5).toFixed(1) + 'px');
      el.className = 'uw-sparkle';

      alive++;
      el.addEventListener('animationend', function () {
        alive--;
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      setTimeout(function () {
        if (el.parentNode) {
          alive--;
          el.parentNode.removeChild(el);
        }
      }, life + 400);

      getLayer().appendChild(el);
    }

    function allowed() {
      return !prefersReducedMotion();
    }

    function burstPoint(detail) {
      if (detail && isFinite(detail.x) && isFinite(detail.y)) {
        return { x: detail.x, y: detail.y };
      }
      var target = detail ? detail.target : null;
      if (target && target.getBoundingClientRect) {
        var r = target.getBoundingClientRect();
        if (r.width || r.height) {
          return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
        }
      }
      return { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    }

    function burst(detail) {
      if (!allowed()) return;
      var at = burstPoint(detail);
      var count = Math.round(rand(BURST_MIN, BURST_MAX));
      for (var i = 0; i < count; i++) {
        emit(at.x, at.y, BURST_SPREAD, rand(BURST_LIFE_MIN, BURST_LIFE_MAX));
      }
    }

    function trailFrame() {
      pending = false;
      if (!allowed()) return;
      var now = Date.now();
      if (now - lastTrail < TRAIL_INTERVAL) return;
      if (alive >= TRAIL_MAX) return;
      lastTrail = now;
      emit(pointerX, pointerY, TRAIL_DRIFT, rand(TRAIL_LIFE_MIN, TRAIL_LIFE_MAX));
    }

    function onPointerMove(e) {
      pointerX = e.clientX;
      pointerY = e.clientY;
      if (pending) return;
      pending = true;
      requestAnimationFrame(trailFrame);
    }

    document.addEventListener('uw:sparkle', function (e) {
      burst(e ? e.detail : null);
    });

    function bindTrail() {
      if (!document.querySelector('[data-uw-sparkle-trail]')) return;
      if (!hasFinePointer()) return;
      document.addEventListener('pointermove', onPointerMove, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindTrail);
    } else {
      bindTrail();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
